"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LENGTH_64 = exports.LENGTH_512 = exports.LENGTH_32 = exports.LENGTH_256 = exports.LENGTH_16 = exports.LENGTH_128 = exports.LENGTH_1024 = exports.LENGTH_1 = exports.LENGTH_0 = void 0;
var LENGTH_0 = 0;
exports.LENGTH_0 = LENGTH_0;
var LENGTH_1 = 1;
exports.LENGTH_1 = LENGTH_1;
var LENGTH_16 = 16;
exports.LENGTH_16 = LENGTH_16;
var LENGTH_32 = 32;
exports.LENGTH_32 = LENGTH_32;
var LENGTH_64 = 64;
exports.LENGTH_64 = LENGTH_64;
var LENGTH_128 = 128;
exports.LENGTH_128 = LENGTH_128;
var LENGTH_256 = 256;
exports.LENGTH_256 = LENGTH_256;
var LENGTH_512 = 512;
exports.LENGTH_512 = LENGTH_512;
var LENGTH_1024 = 1024;
exports.LENGTH_1024 = LENGTH_1024;